<template>
  <div class="bg-main">
    <div class="center-div">
      <img class="img-logo" id="logo_harmoni" src="@/assets/logo.png" alt="logo-mobile" />
      <div v-if="isvalid">
        <a-icon type="loading" class="icon-loading"/>
        <h2 id="loading-text"></h2>
      </div>
      <a-alert v-else class="w-full margin-top" message="Redirect failed, Link Is Not Valid!" type="error" show-icon />
    </div>
  </div>
</template>
<script>
import CryptoJS from "crypto-js";
import axios from "axios";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  props:["id"],
  data(){
    return{
      isvalid: true
    }
  },
  mounted(){
    if(this.id){
      this.templogin()
    }
    this.animation()
  },
  computed: {
    ...mapGetters(["getAuth"])
  },
  methods:{
    moment,
    animation(){
      const loadingTextElement = document.getElementById('loading-text');
      let dotCount = 0;
      const text = "Be patient, HARMONI System is redirecting"
      setInterval(() => {
          // Increment dot count and reset if it exceeds a limit (e.g., 3 dots)
          dotCount = (dotCount % 5) + 1; 

          // Construct the dots string
          const dots = '.'.repeat(dotCount);

          // Update the element's text content
          loadingTextElement.textContent = `${text}${dots}`;
      }, 500); // Update every 500 milliseconds (adjust as needed)
    },
    async templogin(){
      let params = CryptoJS.AES.decrypt(this.id, "IAO-key").toString(CryptoJS.enc.Utf8)
      params = JSON.parse(params)
      let tempTime = moment(params.exp,"YYYY-MM-DD HH:mm:ss").diff(moment(), 'seconds')
      if(!(params && tempTime<=10 && tempTime>=0)){
        this.isvalid = false
      }

      if(!this.isvalid){
        this.$notification.error({
                message: "Error",
                description: "Link is not valid!",
              });
        return;
      }

      axios({
          method: "post",
          url: process.env.VUE_APP_SERVICEURL + "login",
          data: {
            tlc: params.usr,
            password: params.psw,
          }})
      .then((res) => {
        const enc = window.btoa(JSON.stringify(res.data));
        localStorage.setItem("key_", enc);

        const route = this.$router.resolve({
          name: params.page,
          params: { id: params.id },
        });
        window.open(route.href, "_self");
      })
      .catch((error) => {
        // window.open(process.env.VUE_APP_IDEAPP);
        // data = error;
      });
    }
  },
}
</script>
<style lang="less">
#app{
  height: 100%;
  width: 100%;
}

.main-layout{
  height: 100%;
  width: 100%;
}

.ant-layout{
  flex: 1
}

.bg-main{
  display: flex;
  justify-content: center;
  height: 100%;
  background-color: @primary-color;

  .center-div{
    width: 20%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin: auto;
    align-items: center;

    .icon-loading{
      margin-top:2rem;
      font-size: 42px;
      color: white;
    }

    h2{
      margin-top:1rem;
      text-align: center;
      color: white;
    }

    .img-logo {
      width: 100%;
      object-fit: contain;
    }
  }
}
</style>